<script setup lang="ts">
import { computed } from 'vue'
import { ExternalLink } from 'lucide-vue-next'
import type { Citation } from './useResearchChat'
import { extractActualUrl } from './citationUtils'

const props = defineProps<{
  citation: Citation
  index: number
}>()
const emit = defineEmits<{
  select: [citation: Citation]
}>()

const actualUrl = computed(() => {
  return props.citation.url ? extractActualUrl(props.citation.url) : ''
})

const displayTitle = computed(() => {
  return props.citation.title || actualUrl.value || 'Source'
})

const handleClick = () => {
  if (!actualUrl.value) return
  emit('select', props.citation)
}
</script>

<template>
  <button
    type="button"
    class="border-border hover:border-foreground/20 group bg-card flex items-start gap-3 rounded-lg border p-3 text-left transition-all hover:-translate-y-0.5 hover:shadow-md"
    @click="handleClick"
  >
    <div
      class="bg-primary text-primary-foreground flex size-6 shrink-0 items-center justify-center rounded"
    >
      <span class="text-xs font-semibold">{{ index }}</span>
    </div>
    <div class="min-w-0 flex-1">
      <p class="text-foreground line-clamp-2 text-sm font-medium">
        {{ displayTitle }}
      </p>
    </div>
    <ExternalLink
      class="text-muted-foreground group-hover:text-foreground mt-0.5 size-3 shrink-0 transition-colors"
    />
  </button>
</template>
